// Estimates — every estimate the client has been sent. Each opens its public
// page, where it is accepted or declined (the existing workflow).
// Both kinds of access see these (docs/CLIENT_PORTAL.md §4).

import React, { useCallback, useEffect, useState } from 'react';
import { EmptyState, Notice, Pill, RecordList, Skeleton } from '../../../ui/fw';
import { get, money, day } from '../portalApi';
import { estimateState, openEstimate } from '../portalShared';

export default function Estimates({ me, onUnauthorized }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  const several = (me.clients || []).length > 1;

  const load = useCallback(async () => {
    setError(null);
    try {
      const r = await get('/portal/estimates');
      setRows(r.estimates || []);
    } catch (e) {
      if (e.status === 401) onUnauthorized(); else setError(e.message);
    }
  }, [onUnauthorized]);
  useEffect(() => { load(); }, [load]);

  const columns = [
    { key: 'number', label: 'Estimate', role: 'title' },
    ...(several ? [{ key: 'client_name', label: 'For', role: 'subtitle' }] : []),
    { key: 'state', label: 'Status', role: 'badge', render: (r) => { const s = estimateState(r.status); return <Pill tone={s.tone}>{s.label}</Pill>; } },
    { key: 'total', label: 'Total', align: 'right', render: (r) => money(r.total_cents) },
    { key: 'sent', label: 'Sent', render: (r) => day(r.sent_on) },
    { key: 'expires', label: 'Good until', render: (r) => day(r.expires_on) },
  ];

  return (
    <div className="pt-screen" data-screen="portal-estimates">
      <h1 className="pt-h1">Estimates</h1>
      {error ? <Notice tone="stop" title="Estimates could not be loaded" data-note="load-failed">{error}</Notice> : null}
      {!error && !rows ? <Skeleton lines={4} /> : null}
      {rows && rows.length ? <RecordList columns={columns} rows={rows} onRowClick={openEstimate} caption="Estimates" /> : null}
      {rows && !rows.length ? <EmptyState icon="estimates" title="No estimates yet">When we send you an estimate, it is here.</EmptyState> : null}
    </div>
  );
}
